import { FC, SetStateAction, useEffect, useRef } from 'react';
import { useLocalization } from 'Hooks';
import { Box, Typography } from '@material-ui/core';
import { colors, fontSizes, gutters } from 'Theme/Variables';
import { Dispatch } from 'react';
import { useDispatch } from 'react-redux';
import { setDiscoverIsDirectionEnable, setDiscoverSelectedPin } from 'Stores/Maps';
import './MapPopup.scss';
import { DialogCloseComponent } from 'Components/DialogCloseComponent';

type MapPopupProps = {
  title?: string;
  desc?: string;
  distance?: string;
  reset?: any;
};
const MapPopup: FC<MapPopupProps> = ({ title, desc, distance, reset }) => {
  const dispatch = useDispatch();
  const { web_travel_directions } = useLocalization();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Popup açıldığında / pin değiştiğinde focus'u içeri al
    const id = window.setTimeout(() => {
      const firstFocusable = containerRef.current?.querySelector<HTMLElement>('button');
      firstFocusable?.focus();
    }, 0);
    return () => window.clearTimeout(id);
  }, [title, desc]);

  return (
    <div id="mapPopup" ref={containerRef} role="dialog" aria-label={title} tabIndex={-1}>
      <Box position="absolute" top={4} right={2}>
        <DialogCloseComponent closeFunction={() => reset() || dispatch(setDiscoverSelectedPin(undefined))} />
      </Box>
      <Box className="mapPopup">
        <Box className="mapPopup__first-column">
          <Typography variant="h3" component="h1">
            <Box mt={gutters.small} fontWeight={600} color={colors.secondary} fontSize={fontSizes.small}>
              {title}
            </Box>
          </Typography>
          <Typography variant="h3" component="p">
            <Box mt={gutters.small} color={colors.checkboxLabel} fontSize="13px">
              {desc}
            </Box>
          </Typography>
          <Typography variant="h3" component="p">
            <Box color={colors.checkboxLabel} fontSize="13px" mt={gutters.small}>
              {distance ? `${distance} km` : ''}
            </Box>
          </Typography>
        </Box>
        <Box className="mapPopup__second-column">
          <Typography variant="h3" component="span">
            <Box
              mt={2}
              onClick={() => dispatch(setDiscoverIsDirectionEnable(true))}
              className="mapPopup__second-column__link"
              fontSize="13px"
              color={colors.primary}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  dispatch(setDiscoverIsDirectionEnable(true));
                }
              }}
            >
              {web_travel_directions}
            </Box>
          </Typography>
        </Box>
      </Box>
    </div>
  );
};
export default MapPopup;
